import { React } from "react";
import { Link } from "react-router-dom";

function Logo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="45"
      height="45"
      version="1"
      viewBox="0 0 90 90"
    >
      <path
        d="M95 886c-41-18-83-69-90-109-3-18-5-177-3-354C5 116 6 100 26 74c11-15 33-37 48-48C101 6 114 5 450 5s349 1 376 21c15 11 37 33 48 48 20 27 21 40 21 376s-1 349-21 376c-11 15-33 37-48 48-26 20-42 21-364 23-265 2-344 0-367-11zm705-34c67-33 70-48 70-402s-3-369-70-402c-31-16-70-18-350-18s-319 2-350 18C33 81 30 96 30 450c0 280 2 319 18 350 33 67 48 70 402 70 280 0 319-2 350-18z"
        transform="matrix(.1 0 0 -.1 0 90)"
      ></path>
      <path
        d="M388 737c-95-27-176-104-199-191-25-93-8-208 42-280 86-125 301-148 416-43l22 20-26 33c-30 39-41 41-85 14-51-31-137-28-178 6-47 40-64 80-64 154 0 101 50 171 133 185 40 7 116-8 126-25 13-21 52-10 75 22 28 39 21 54-41 86-57 28-157 37-221 19z"
        transform="matrix(.1 0 0 -.1 0 90)"
      ></path>
    </svg>
  );
}

export const BrandLogo = ({ close }) => {
  return (
    <div className="flex-1 -ml-12 desktop:m-0">
      <Link to="/" onClick={close}>
        <Logo />
      </Link>
    </div>
  );
};
